//
//
// ===========================================================================

$('#offCanvas').offcanvas({
    role: "dialog",
    modifiers: "right,overlay",
    baseClass: "c-offcanvas",
    modalClass: "c-offcanvas-bg",
    contentClass: "c-offcanvas-content-wrap",
    closeButtonClass: "js-offcanvas-close",
    bodyModifierClass: "has-offcanvas",
    supportNoTransitionsClass: "support-no-transitions",
    resize: false,
    triggerButton: '#triggerButton' ,
    modal: true,
    onOpen: function() {},
    onClose: function() {},
    onInit: function() {}
});



$('#search').offcanvas({
    role: "dialog",
    modifiers: "top,overlay",
    baseClass: "c-offcanvas",
    modalClass: "c-offcanvas-bg",
    contentClass: "c-offcanvas-content-wrap",
    closeButtonClass: "js-offcanvas-close",
    bodyModifierClass: "has-offcanvas",
    supportNoTransitionsClass: "support-no-transitions",
    resize: false,
    triggerButton: '#searchButton' ,
    modal: true,
    onOpen: function() {},
    onClose: function() {},
    onInit: function() {}
});

var navOffCanvas = $('#offCanvas').data('offcanvas-component');
var searchOffCanvas = $('#search').data('offcanvas-component');

searchOffCanvas.onOpen = function() {
    navOffCanvas.close();
};

navOffCanvas.onOpen = function() {
    searchOffCanvas.close();
};


$( window ).resize(function() {
  searchOffCanvas.close();
  navOffCanvas.close();
});
